<template>
  <!--
      	描述：diy组件-模拟显示-登录
      -->
  <div @click.stop="$parent.$parent.onEditer(index)">
    <div class="drag optional" :class="{selected:index === selectedIndex}">
      <div class="diy-login">
        <ul class="login-list" :class="'column-1'" :style="{background:item.style.background}">
          <li class="item" :key="index" v-for="(login,index) in item.data">
            <div class="d-c d-s-s">
              <div class="item-text1 text-ellipsis">
                <div class="login-logo" :style="{backgroundImage:'url('+login.imageUrl+')'}"></div>{{login.title}}
              </div>
              <div class="item-text2 text-ellipsis" :style="{color:login.color}">
                {{login.text}}
              </div>
            </div>
            <div class="item-loginbtn">
              <span>{{$t('登录')}}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="btn-edit-del">
        <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">{{$t('删除')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  props: ['item', 'index', 'selectedIndex'],
  methods: {

  }
};
</script>

<style lang="scss">
.diy-login .login-list {
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}
.diy-login .login-list .item {
  padding: 10px;
  display: flex;
  background: #FFFFFF;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.16);
  border-radius: 9px;
  box-sizing: border-box;
}
.login-logo{
  width: 18px;
  height: 18px;
  border-radius: 10px;
  display: inline-block;
  background-color: #C8C8C8;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 8px;
}

.diy-login .login-list.column-1 .item {
  width: 345px;
  height: 75px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
}
.diy-login .login-list .item-text1 {
  width: 100%;
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  display: flex; align-items: center;
}
.diy-login .login-list .item-text2 {
  width: 100%;
  padding: 4px 0;
  font-weight: 400;
  color: #999999;
  font-size: 11px;
}
.item-loginbtn{
  width: 70px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  background: linear-gradient(to right, #FFCB8C, #FFFCE6);
}
.item-loginbtn span{
  font-size: 13px;
  font-weight: 600;
  color: #FF7A00;
}
</style>



// WEBPACK FOOTER //
// src/components/buildStore/website/homePageEdit/model/Login.vue